import cs from 'classnames';
import Image from 'next/image';
import type { FC } from 'react';
import { Accordion, Button } from '@/DesignSystem/Component';
import { APPLICATION_TITLE, FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { IconAngleTop, IconLocation, IconTell } from '@/Module/Icon';
import DefaultLayoutFooterMenu from './DefaultLayoutFooterMenu';
const headerContent = <div className="flex cursor-pointer items-center justify-between bg-blueTwo">
    <span className="inline-flex flex-1  px-6 py-4 font-bold text-blueFive">کجا می‌ری؟</span>
    <IconAngleTop className={cs('text-blueFive transition-all duration-300 ease-in-out group-[.ui--is-open]:rotate-180')} />
  </div>;
const bodyContent = <DefaultLayoutFooterMenu className="mobile mb-4 flex-col !items-start justify-start gap-4 bg-blueTwo pr-8 text-blueFive" />;
export const DefaultLayoutFooterTop: FC = () => {
  return <div className="bg-blueFive pt-6 md:py-10" data-sentry-component="DefaultLayoutFooterTop" data-sentry-source-file="DefaultLayoutFooterTop.tsx">
      <div className="container">
        <DefaultLayoutFooterMenu className="hidden md:flex" data-sentry-element="DefaultLayoutFooterMenu" data-sentry-source-file="DefaultLayoutFooterTop.tsx" />
        <div className="flex flex-col gap-8 md:flex-row md:items-baseline lg:gap-24">
          <div className="md:pt-6">
            <div className="mt-4 flex items-center gap-3">
              <Image width={40} height={32} src={`${FILE_BROWSER_URL}/img/img-logo.svg`} alt={APPLICATION_TITLE} data-sentry-element="Image" data-sentry-source-file="DefaultLayoutFooterTop.tsx" />
              <span className="text-lg font-bold">{APPLICATION_TITLE}</span>
            </div>
            <p className="leading-8 mt-4 pt-2 text-justify text-blueTwo">
              آی‌نو یه سامانه آموزش مجازی درجه یک درست وسط اینترنته که یه تیم از معلم‌‌های خفن و کاربلد رو دور هم جمع کرده تا
              بهت ثابت کنه اگر معلمت خفن و کاردرست باشه؛ درس خوندن خیلی آسون‌تر و باحال‌تر از چیزیه که فکرش رو می‌کنی. پس سخت
              نگیر، یاد بگیر!
            </p>
          </div>

          <div>
            <Button className="mb-4" as="a" href="tel://02128425510" variant="contained" color="primaryMiddle" beforeIcon={<IconTell size="small" />} bold data-sentry-element="Button" data-sentry-source-file="DefaultLayoutFooterTop.tsx">
              ۰۲۱-۲۸۴۲۵۵۱۰
            </Button>
            <div className="mb-2">
              <div className="mb-1 flex items-center gap-1">
                <IconLocation size="small" className="!justify-start text-white" data-sentry-element="IconLocation" data-sentry-source-file="DefaultLayoutFooterTop.tsx" />
                <span className="font-bold text-white">نشانی :</span>
              </div>
              <p className="leading-8 text-blueTwo">
                تهران، میدان عطار، خیابان عطار، پلاک 26، ساختمان پروین اعتصامی، طبقه 3
              </p>
            </div>
          </div>
        </div>
      </div>
      <Accordion header={headerContent} defaultIsOpen className="flex flex-col border-4 border-blueFive bg-blueTwo md:hidden" data-sentry-element="Accordion" data-sentry-source-file="DefaultLayoutFooterTop.tsx">
        {bodyContent}
      </Accordion>
    </div>;
};